import { get, isEmpty, isNil } from 'lodash';

import { DecimalNumber } from '@app/shared/common/decimal-number/decimal-number';
import { EVENT_STATUS_VALUE } from '@app/shared/types/enums/event-status.enum';

import {
  IQtyCalculatorParams,
  ReplenishQtyCalculator,
} from './calculators.types';

const expectQtyCalculator: ReplenishQtyCalculator = (
  params: IQtyCalculatorParams,
) => {
  const { threshold, replenishType, percent, measureFactor, additionalData } =
    params;

  const replenishQuantity: DecimalNumber = new DecimalNumber(
    get(threshold, replenishType) || 0,
  )
    .mul(percent)
    .div(100);

  const standWorkSheetData = get(additionalData, 'standWorkSheetData', {});

  const standWorksheetItem = get(standWorkSheetData, 'item', {});
  const lastEventOfDestination = get(standWorkSheetData, 'recentEvent');

  let valueInCalculationsOfAdjustReplenish = 0;

  if (!isEmpty(standWorksheetItem) && !isNil(lastEventOfDestination)) {
    switch (lastEventOfDestination.status) {
      case EVENT_STATUS_VALUE.Open:
        // valueInCalculationsOfAdjustReplenish = Expected Qty
        valueInCalculationsOfAdjustReplenish = get(
          standWorksheetItem,
          'expected_qty',
          0,
        );
        break;
      case EVENT_STATUS_VALUE.Closed:
        // valueInCalculationsOfAdjustReplenish = Ending Count
        valueInCalculationsOfAdjustReplenish = get(
          standWorksheetItem,
          'end',
          0,
        );
        break;
      default:
        break;
    }
  }

  // Quantity Request = (PAR * percentage * factor value of PAR measure) / factor value of Transfer Unit - valueInCalculationsOfAdjustReplenish
  // then / factor value of inventory item
  const replenishmentValue = replenishQuantity
    .mul(measureFactor.threshold)
    .sub(valueInCalculationsOfAdjustReplenish)
    .div(measureFactor.item);

  return replenishmentValue;
};

export { expectQtyCalculator };
